var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSku(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.846191 13.6537V0.730713H2.69219V13.6537H0.846191ZM3.61544 13.6537V0.730713H5.46144V13.6537H3.61544ZM6.38469 13.6537V0.730713H7.30769V13.6537H6.38469ZM9.15369 13.6537V0.730713H10.9999V13.6537H9.15369ZM11.9229 13.6537V0.730713H14.6922V13.6537H11.9229ZM15.6152 13.6537V0.730713H16.5384V13.6537H15.6152ZM18.3844 13.6537V0.730713H21.1537V13.6537H18.3844Z",
    fill: "#111111",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSku);
export default __webpack_public_path__ + "static/media/icon-sku.2eda70a0d7933f0cabeb1e4ff942f0c8.svg";
export { ForwardRef as ReactComponent };